import { module } from 'modujs';
import { html } from '../utils/environment';

const SOUND_URL = './assets/sound/TheHoly_Lvcidia.mp3'
const HOVER_URL = './assets/sound/door_tick1.mp3'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                hoverSound: 'hover',
            },
            click: {
                muteButton: 'toggleMute'
            }
        }
    }

    init() {
        this.isPlaying = false;
        this.mutedByUser = false;
    }

    loadSound() {
        if(window.isMobile) return;

        this.sound = new Audio(SOUND_URL);
        this.sound.loop = true;

        this.hoverSound = new Audio(HOVER_URL);

        this.sound.addEventListener('canplay', () => {
            this.sound.play();
        })

        this.sound.addEventListener('play', () => {
            this.isPlaying = true;
        })

        this.sound.addEventListener('pause', () => {
            this.isPlaying = false;
        })
    }

    play() {
        if(window.isMobile || this.mutedByUser) return
        this.sound.play()
    }

    pause() {
        if(window.isMobile || this.mutedByUser) return
        this.sound.pause()
    }

    toggleMute() {
        if(this.mutedByUser) {
            this.unmute()
        } else {
            this.mute()
        }
    }

    mute() {
        this.mutedByUser = true;
        this.sound.pause()
        html.classList.add('has-sound-muted')
    }

    unmute() {
        this.mutedByUser = false;
        this.sound.play()
        html.classList.remove('has-sound-muted')
    }

    hover() {
        if(window.isMobile || this.mutedByUser) return
        this.hoverSound.play()
    }
}
